import mapboxgl from 'mapbox-gl';
// @ts-ignore - Vite worker import
import MapboxWorker from 'mapbox-gl/dist/mapbox-gl-csp-worker?worker';

mapboxgl.workerClass = MapboxWorker;
